// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                           from 'firebase/functions';

// ===== Interfaces =====

import {
    IUnsubscribeByMailTrackingLinkResult,
}                                           from '../interfaces';

const unsubscribeByMailTrackingLink = async ({
    test,
    mailTrackingId,
}: {
    test: boolean,
    mailTrackingId: string,
}): Promise<IUnsubscribeByMailTrackingLinkResult> => {
    const functions = getFunctions();
    const handleUnsubscribeByMailTrackingLink = httpsCallable<
        Record<string, boolean | string>,
        IUnsubscribeByMailTrackingLinkResult
    >(
        functions,
        'unsubscribeByMailTrackingLink',
    );
    return handleUnsubscribeByMailTrackingLink({
        test,
        mailTrackingId,
    }).then((result) => result.data as IUnsubscribeByMailTrackingLinkResult).catch((err) => {
        throw err;
    });
};

export default unsubscribeByMailTrackingLink;
